import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import { MerchantBulkCreateComponent } from './merchant-bulk-create.component';
import { MerchantBulkCreateRouter } from './merchant-bulk-create.router';

/** @constant {angular.module} */
const merchantBulkCreate = angular
  .module('ec.opsCenter.ops-support.merchant-bulk-create', [])
  .config(MerchantBulkCreateRouter)
  .directive('appMerchantBulkCreate', downgradeComponent({ component: MerchantBulkCreateComponent }) as angular.IDirectiveFactory).name;

export default merchantBulkCreate;



// WEBPACK FOOTER //
// ./src/app/ops-support/merchant-bulk-create/merchant-bulk-create.module.ajs.ts